import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IIntern, IInternState, IInternDetailsSchema } from './types';

const initialState: IInternState = {
  interns: {},
  updateInternStatus: {},
  internDetails: {},
  getTransaction: {},
  updateIntern: {},
  promoteAsEmployee: {},
};

const slice = createSlice({
  name: 'intern',
  initialState,
  reducers: {
    getInterns(state) {
      state.interns.status = RequestStatus.RUNNING;
    },
    getInternsSuccess(state, action: PayloadAction<IInternState['interns']['data']>) {
      state.interns.status = RequestStatus.SUCCESS;
      state.interns.data = action.payload;
    },
    getInternsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.interns.status = RequestStatus.ERROR;
      state.interns.error = action.payload;
    },
    //
    updateIntern(state, action) {
      state.updateIntern.status = RequestStatus.RUNNING;
    },
    updateInternSuccess(state, action: PayloadAction<IIntern>) {
      state.updateIntern.status = RequestStatus.SUCCESS;
      state.updateIntern.data = action.payload;
    },
    updateInternFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateIntern.status = RequestStatus.ERROR;
      state.updateIntern.error = action.payload;
    },
    //
    updateInternStatus(state, action: PayloadAction<any>) {
      state.updateInternStatus.status = RequestStatus.RUNNING;
    },
    updateInternStatusSuccess(state, action: PayloadAction<IIntern>) {
      state.updateInternStatus.status = RequestStatus.SUCCESS;
      state.updateInternStatus.data = action.payload;
    },
    updateInternStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateInternStatus.status = RequestStatus.ERROR;
      state.updateInternStatus.error = action.payload;
    },
    //
    getInternDetails(state, action: PayloadAction<IInternDetailsSchema>) {
      state.internDetails.status = RequestStatus.RUNNING;
    },
    getInternDetailsSuccess(state, action: PayloadAction<IInternState['internDetails']['data']>) {
      state.internDetails.status = RequestStatus.SUCCESS;
      state.internDetails.data = action.payload;
    },
    getInternDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.internDetails.status = RequestStatus.ERROR;
      state.internDetails.error = action.payload;
    },
    //
    getInternTransaction(state, action: PayloadAction<IInternDetailsSchema>) {
      state.getTransaction.status = RequestStatus.RUNNING;
    },
    getInternTransactionSuccess(
      state,
      action: PayloadAction<IInternState['getTransaction']['data']>
    ) {
      state.getTransaction.status = RequestStatus.SUCCESS;
      state.getTransaction.data = action.payload;
    },
    getInternTransactionFailed(state, action: PayloadAction<IRequestFailed>) {
      state.getTransaction.status = RequestStatus.ERROR;
      state.getTransaction.error = action.payload;
    },
    promoteAsEmployee(state, action) {
      state.promoteAsEmployee.status = RequestStatus.RUNNING;
    },
    promoteAsEmployeeSuccess(state, action: PayloadAction<IIntern>) {
      state.promoteAsEmployee.status = RequestStatus.SUCCESS;
      state.promoteAsEmployee.data = action.payload;
    },
    promoteAsEmployeeFailed(state, action: PayloadAction<IRequestFailed>) {
      state.promoteAsEmployee.status = RequestStatus.ERROR;
      state.promoteAsEmployee.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getInterns,
  getInternsSuccess,
  getInternsFailed,
  updateInternStatus,
  updateInternStatusFailed,
  updateInternStatusSuccess,
  getInternDetails,
  getInternDetailsSuccess,
  getInternDetailsFailed,
  getInternTransaction,
  getInternTransactionFailed,
  getInternTransactionSuccess,
  updateIntern,
  updateInternSuccess,
  updateInternFailed,
  promoteAsEmployee,
  promoteAsEmployeeFailed,
  promoteAsEmployeeSuccess,
} = slice.actions;
